import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const ProductCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0 0 5px;
`;

export const ProductInfo = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const ProductHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
  border-radius: 6px 6px 0 0;
  background: #e2e2e2;
`;

export const ProductTitle = styled.h6`
  margin: 0;
  line-height: 130%;
  font-size: 14px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  letter-spacing: -0.1px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: nowrap;
`;

export const ProductPrice = styled.p`
  margin-left: ${({ theme }) => (!theme.isRtl ? '10px' : '0')};
  line-height: 130%;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`;

export const CheckItOut = styled.a`
  color: rgb(0 0 0);
  line-height: 119%;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.14px;
`;

export const YotpoRatingContainer = styled.div`
  display: flex;
  align-items: stretch;
  margin-right: ${({ theme }) => (theme.isRtl ? 'auto' : '0')};
  margin-left: ${({ theme }) => (!theme.isRtl ? 'auto' : '0')};
  gap: 5px;

  & > svg {
    margin-top: ${({ theme }) => (theme.isRtl ? '2px' : '0')};
  }

  & > svg > path {
    fill: #ffc107;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;
  min-height: 250px;
  max-height: 250px;
  padding: 10px 0 0;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 0 0 6px 6px;
  background: #fff;

  img {
    display: block;
    max-width: 100%;
    cursor: pointer;
    border-radius: 6px;
  }
`;

export const ImageContainerFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 7px 10px 5px;
`;

export const ProductButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  width: 100%;
  height: 30px;
  color: ${({ theme }) => theme.colors.light};
  line-height: 14px;
  font-size: 12px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontFamily};
  letter-spacing: 0.12px;
  cursor: pointer;
  border: none;
  border-radius: 6px;
  background: #000;
  outline: none;
  -webkit-box-align: center;
  -webkit-box-pack: center;

  ${({ theme }) => css`
    @media (${theme.mediaMobile}) {
      font-size: 13px;
    }

    @media not (${theme.mediaMobile}) {
      font-size: 12px;
    }
  `}
`;

export const ErrorText = styled.p`
  margin: 20px 0 10px !important;
  color: #c15050;
  line-height: 130%;
  font-size: 14px;
  font-weight: 500;
`;
